import { useTenant } from '@/contexts/TenantContext'
import styles from './TenantIdentity.module.css'

type Props = {
  showSlug?: boolean
  className?: string
}

/** Badge compacto: nome da empresa (e opcionalmente slug). */
export function TenantBadge({ showSlug = false, className }: Props) {
  const { nome, slug, logoUrl } = useTenant()

  return (
    <div className={[styles.badge, className].filter(Boolean).join(' ')} title={showSlug ? `ID: ${slug}` : nome}>
      {logoUrl ? (
        <img src={logoUrl} alt="" className={styles.badgeLogo} />
      ) : (
        <span className={styles.badgeInitial} aria-hidden>
          {nome.charAt(0).toUpperCase()}
        </span>
      )}
      <span className={styles.badgeText}>
        <span className={styles.badgeNome}>{nome}</span>
        {showSlug && <span className={styles.badgeSlug}>{slug}</span>}
      </span>
    </div>
  )
}
